var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('select',{domProps:{"value":_vm.value},on:{"change":_vm.updateLocale}},_vm._l((_vm.locales),function(locale){return _c('option',{key:locale.id,domProps:{"value":locale.id}},[_vm._v(" "+_vm._s(locale.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }